import { useState } from "react";
import PropTypes from "prop-types";
import { BbotButton, BbotModal } from "top-component-library";

// Deviation from legacy: deleteCustomer() fires with zero confirmation of any kind. A hard,
// cascading delete with no confirmation step is worth the deviation - added a plain
// confirm here (not a typed-name prompt like Deactivate/DeleteStation, since there's no
// legacy precedent dictating one for this specific action).
const DeleteCustomerDialog = ({ onClose, onConfirm }) => {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    const succeeded = await onConfirm();
    setDeleting(false);
    if (succeeded) onClose();
  };

  return (
    <BbotModal
      title="Are you sure you want to delete this customer?"
      visible
      onCancel={onClose}
      footer={[
        <BbotButton key="cancel" onClick={onClose}>
          Never mind, go back!
        </BbotButton>,
        <BbotButton key="confirm" type="primary" danger loading={deleting} onClick={handleConfirm}>
          Confirm
        </BbotButton>,
      ]}
    >
      <p>This permanently deletes the customer and cannot be undone.</p>
    </BbotModal>
  );
};

DeleteCustomerDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteCustomerDialog;
